import View from 'ln/view/View';
import VideoPlayer from '../VideoPlayer';
import { toMSString } from './helpers';

class TimeDisplay extends View{

    data: { current:string, total:string };

    constructor( public player:VideoPlayer ){
        super();

        this.data = { current: '0:00', total: '0:00' };
        this.defaultTemplate = 'lv.video-time';

        this.player.duration.add( this.setUp, this );
        this.player.time.add( this.update, this );
    }

    protected renderData(){
        return this.data;
    }

    private setUp( duration:number ){
        // this.data.total = toMSString( duration );
        // this.render( this.node );
        this.node.js( 'total' ).html = toMSString( duration );
    }

    private update( currentTime:number ){
        // this.data.current = toMSString( currentTime );
        // this.render( this.node );
        this.node.js( 'current' ).html = toMSString( currentTime );
    }
}

export default TimeDisplay;